import "bootstrap";
import 'lightgallery/dist/js/lightgallery-all.min';


import {toggleMobileMenu} from "../blocks/menu_mobile/menu_mobile";
import {languageDropDown} from "../blocks/lang/lang";
import {contactsDropDown} from "../blocks/contacts/contacts";
import {consoleInformer} from "../_helpers/ff_console/ff_console";
import {slider} from "../blocks/slider/slider";
import {questionnaireScript} from "../blocks/questionnaire/questionnaire";
import clientsFilter from "../blocks/clients_filter/clients_filter"

toggleMobileMenu();
languageDropDown();
contactsDropDown();
consoleInformer();
slider();
questionnaireScript();



$(document).ready( function () {
    clientsFilter.init();

    $('.light_gallery_image').lightGallery({
        share: false,
        download: false,
        thumbnail:true,
        rotate: false,
        counter: false,
    });

    $('.questionnaire').on("submit", function (event){
        const params = {};
        params[FB.AppEvents.ParameterNames.REGISTRATION_METHOD] = 'order';
        FB.AppEvents.logEvent(FB.AppEvents.EventNames.COMPLETED_REGISTRATION, null, params);
    });
    $('#steps').on('click', function () {
        $('html, body').animate({
            scrollTop: $('#steps').offset().top
        }, 300, function(){
            window.location.hash = 'steps';
        });
    });


    $("#subscriptionForm").on("submit", function (event) {
        event.preventDefault();
        const data = $(this).serialize();
        const buttonVal = ($(this).find("input[type='submit']").val());
            $.ajax({
                url: '/add_subscription',
                type: 'post',
                data: data,
                success(result) {
                    gtag('event', 'subscribe-send', {
                        'send_to': 'UA-167093660-1',
                        'event_category': 'subscriptionForm',
                        'event_label': buttonVal,
                    });
                    $("#subscriptionModal").modal('show');
                    setTimeout(() => {
                        $("#subscriptionForm")[0].reset();
                        $("#subscriptionModal").modal('hide');
                    }, 5000);
                    const params = {};
                    params[FB.AppEvents.ParameterNames.REGISTRATION_METHOD] = 'subscription';
                    FB.AppEvents.logEvent(FB.AppEvents.EventNames.COMPLETED_REGISTRATION, null, params);
                },
                error(msg) {
                    console.log(msg);
                },
            });
    });
    $('.banner_button').on('click', (e) => {
        e.preventDefault();
        const buttonVal = ($('.banner_button').text());
        gtag('event', 'redirect', {
            'send_to': 'UA-167093660-1',
            'event_category': 'bannerButton',
            'event_label': buttonVal,
        });
    });
    $('.header_button').on('click', () => {
        const buttonVal = ($('.header_button').text());
        gtag('event', 'redirect', {
            'send_to': 'UA-167093660-1',
            'event_category': 'headerButton',
            'event_label': buttonVal,
        });
    });
    $('.header_button--desk').on('click', () => {
        const buttonVal = ($('.header_button--desk').text());
        gtag('event', 'redirect', {
            'send_to': 'UA-167093660-1',
            'event_category': 'headerButton',
            'event_label': buttonVal,
        });
    });
    $('.consultation_button').on('click', () => {
        const buttonVal = ($('.consultation_button').text());
        gtag('event', 'redirect', {
            'send_to': 'UA-167093660-1',
            'event_category': 'consultationButton',
            'event_label': buttonVal,
        });
    })
    $('.price_button').on('click', () => {
        const buttonVal = ($('.price_button').text());
        gtag('event', 'redirect', {
            'send_to': 'UA-167093660-1',
            'event_category': 'priceButton',
            'event_label': buttonVal,
        });
    });
    $('.questionnaire').on('submit', function () {
        const formType = $(this).find('input[name="type"]:checked').val();
        const formTypeId = $(this).find('input[name="type"]:checked').attr('id');
        const labelText = $('label[for="' + formTypeId + '"]').html();
        if (formType == 'simple'){
            gtag('event', 'sendForm', {
                'send_to': 'UA-167093660-1',
                'event_category': 'simpleForm',
                'event_label': labelText,
            });
        } else {
            gtag('event', 'sendForm', {
                'send_to': 'UA-167093660-1',
                'event_category': 'fullForm',
                'event_label': labelText,
            });
        }
    })
});
$( window ).on( "load",() => {
    clientsFilter.initStickySidebar();
});



// WEBPACK FOOTER //
// ./private/pages/main.js